import store from '@/store';
import { locale } from '@/plugins/i18n';

export default {
  data() {
    return {
      email: window?.SB?.user?.email,
    };
  },
  computed: {
    title() {
      if (this.$context.is.buyNow || this.$context.is.basic2pro || this.$context.is.buyTrial) {
        const { firstName, lastName } = store.getters.account;
        let username = firstName;
        if (locale === 'jp-JP') {
          username = lastName;
        }
        if (username && username.length <= 18) {
          return this.$t('billing.success.confirmation.thank_you_for_choosing_zoom_with_user_name', [username]);
        }
      }
      return '';
    },
  }
}
